import moment from 'moment';

const API_ROUTES_ROOT = '/api';

export const PRIVACY_POLICY_URL = 'https://www.reedbusiness.com/privacy-policy';

export const anyToken = 'ANY_b3bf5373-8185-4e81-8883-8c2fbb32e4ce';

export const API_ROUTES = {
  users: API_ROUTES_ROOT + '/admin/users',
  user: API_ROUTES_ROOT + '/admin/user/:id',
  sudoAs: API_ROUTES_ROOT + '/admin/user/sudo',
  accounts: API_ROUTES_ROOT + '/admin/accounts',
  sessions: API_ROUTES_ROOT + '/admin/sessions',
  account: API_ROUTES_ROOT + '/admin/account/:id',
  accountUsers: API_ROUTES_ROOT + '/admin/account/:id/users',
  accountEntitlements: API_ROUTES_ROOT + '/admin/entitlements/account/:id',
  userEntitlements:
    API_ROUTES_ROOT + '/admin/entitlements/account/:accountId/user/:id',
  allUserEntitlements:
    API_ROUTES_ROOT + '/admin/entitlements/account/:accountId/users',
  addUserToOrgNode:
    API_ROUTES_ROOT +
    '/admin/entitlements/account/:accountId/org/:orgNodeId/users',
  tripGroupUsers: API_ROUTES_ROOT + '/tripGroup/:tripGroupId/users',
  tripGroupsUsers: API_ROUTES_ROOT + '/tripGroups/users',
  travelerProfiles: API_ROUTES_ROOT + '/traveler/:email',
  tripsIssuesAwayProfiles: API_ROUTES_ROOT + '/tripsIssuesAwayProfiles',
  trips: API_ROUTES_ROOT + '/trips',
  tripById: API_ROUTES_ROOT + '/trip/:id',
  searchTrips: API_ROUTES_ROOT + '/trips/search?:searchParams',
  searchIssues: API_ROUTES_ROOT + '/issues/search?:searchParams',
  issueGet: API_ROUTES_ROOT + '/issue/:id',
  issueState: API_ROUTES_ROOT + '/issues/state',
  issueAssign: API_ROUTES_ROOT + '/issues/assign',
  issueComment: API_ROUTES_ROOT + '/issues/comment',
  issueDefer: API_ROUTES_ROOT + '/issues/defer',
  issueAssignees: API_ROUTES_ROOT + '/issues/assignees',
  issueReporting: API_ROUTES_ROOT + '/issues/report',
  userTripGroups: API_ROUTES_ROOT + '/user/tripGroups',
  airports: API_ROUTES_ROOT + '/airports',
  airlines: API_ROUTES_ROOT + '/airlines',
  countries: API_ROUTES_ROOT + '/countries',
  waivers: API_ROUTES_ROOT + '/waivers',
  waiver: API_ROUTES_ROOT + '/waivers/:waiverId',
  waiverUpdateChangeEventId: API_ROUTES_ROOT + '/waiverChangeEvent/:id',
  waiverConfigurations: API_ROUTES_ROOT + '/waivers/configurations',
  waiverConfiguration: API_ROUTES_ROOT + '/waivers/configurations/:airlineCode',
  waiverDocuments: API_ROUTES_ROOT + '/waivers/documents',
  waiverDocument: '/waiverDocuments/:documentId/:fileName',
  waiverReporting: API_ROUTES_ROOT + '/waivers/report',
  waiverReportTripCount: API_ROUTES_ROOT + '/waivers/reportTripCount',
  waiverAirlines: API_ROUTES_ROOT + '/waivers/airlines',
  waiverWorkItemImage: (workItemId: number, imageName: string) =>
    `/api/waiverWorkItem/${workItemId}/image/${imageName}`,
  waiverWorkItemAttachment: (workItemId: number, attachmentName: string) =>
    `/api/waiverWorkItem/${workItemId}/attachment/${attachmentName}`,
  sessionAlive: API_ROUTES_ROOT + '/sessionAlive',
  waiverConfigurationService: API_ROUTES_ROOT + '/waiverConfigurations/:airlineCode',
  waiverConfigurationsService: API_ROUTES_ROOT + '/waiverConfigurations',
  waiverAirlinesService: API_ROUTES_ROOT + '/waiverAirlines',
  getallroles: (userId: string) => API_ROUTES_ROOT + `/getallroles/${userId}`,
  generatepassword: API_ROUTES_ROOT + '/admin/account/user/generatepassword',
  resetPassword: '/forgot',
};

export const COMPANY_COPYRIGHT = `Copyright ©  ${moment().format(
  'YYYY',
)} LNRS Data Services Inc.`;

// export const SSO_MIGRATION_MESSAGE = `
//   We will be migrating to Single Sign On (SSO) that will allow seamless navigation across all Cirium solutions. 
//   Your email address in your user profile will become your username. 
//   This must be a valid email address as the migration process will require you to verify it.`;

export const USER_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const USER_ROLE = {
  AGENT: 'Agent',
  // ADMINISTRATOR: 'Administrator',
  ACCOUNT_ADMIN: 'Administrator',
  SUPER_ADMIN: 'Super Admin',
  TRAVELER: 'Traveler',
};

// a reverse USER_ROLE mapping
export const DISPLAY_TO_ROLE = Object.keys(USER_ROLE).reduce((acc: { [key: string]: string }, key: string) => {
  acc[USER_ROLE[key as keyof typeof USER_ROLE]] = key;
  return acc;
}, {});

export const STATUS_TO_BOOL = {
  [USER_STATUS.ACTIVE]: true,
  [USER_STATUS.INACTIVE]: false,
};
export const BOOL_TO_STATUS = {
  true: USER_STATUS.ACTIVE,
  false: USER_STATUS.INACTIVE,
};

export const CONDUCIVE_USER_ACCOUNT_ID = '345';

export const UNKNOWN = 'Unknown'

export const SUPPORT_LINK = 'https://helpdesk.cirium.com/s/contactsupport';

export const SUPPORT_EMAIL = 'helpdesk@cirium.com';

export const WAIVER_STATUS_PENDING = 'PENDING';

export const WAIVER_STATUS_CANCELLED = 'CANCELLED';

export const WAIVER_STATUS_ACTIVE = 'ACTIVE';

export const SUPER_ADMIN_ACCOUNT_ID = '345';

export const ADMIN_USER_ROLES = {
  REGULAR: 'REGULAR',
  ACCOUNTADMIN: 'ACCOUNT_ADMIN',
  SYSADMIN: 'SYSADMIN',
  AGENT: 'AGENT',
  CONDUCIVE: 'CONDUCIVE',
  SUPERADMIN: 'SUPER_ADMIN',
  SUDOLOGIN: 'SUDOLOGIN'
};


export const FLIGHT_SEARCH_DATE_FORMAT = 'yyyy-MM-dd';

export const DATE_PICKER_DEFAULT_FORMAT = 'dd-MMM-yyyy';

export const resetPasswordMessage = (email: string) => `Password was successfully reset. The user details have been saved to the database and an email was sent to the user (${email})`;

export const SUPER_ADMIN = 'super-admin';